import { useAuth, useUser } from "@clerk/clerk-react";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { routeTree } from "./routeTree.gen";

const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

function App() {
  const auth = useAuth();
  const { user } = useUser();

  useEffect(() => {
    if (user && window.pendo) {
      window.pendo.initialize({
        visitor: {
          id: user.id,
          email: user.primaryEmailAddress?.emailAddress,
          full_name: user.fullName,
        },
        account: {
          id: user.id,
        },
      });
    }
  }, [user]);

  // Wait for Clerk to finish loading before rendering the router
  // This prevents redirect loops when checking authentication state
  if (auth.isLoaded === false) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#fafafa]">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  return (
    <RouterProvider
      router={router}
      context={{
        auth: {
          isAuthenticated: auth.isSignedIn ?? false,
          userId: auth.userId,
        },
      }}
    />
  );
}

export default App;
